import { ChangeDetectorRef, Component, Input, TemplateRef, EventEmitter, Output } from "@angular/core";
import { WizardComponent } from "ngx-wizard";
import { Order } from "../../../../../objects/orders/order";
import { CalculatorType } from "../../../../../objects/orders/calculatorType";
import { CalculatorHelper } from "../../../../../common/helpers/calculatorHelper";
import { OrderItemOptions } from "../../../../../objects/orders/orderItemOptions";
import { OrderItem } from "../../../../../objects/orders/orderItem";
import { GoogleTagService } from "../../../../../services/google-tag.service";
import { PageVisit } from "../../../../../objects/pages/pageVisit";

@Component({
    selector: "canadian-questions-tab-v2",
    templateUrl: "./canadian-questions-tab-v2.component.html",
    moduleId: module.id.toString()
})
export class CanadianQuestionsTabV2Component {

    @Input()
    public wizardComponent: WizardComponent;

    @Input()
    public order: Order;
    @Input()
    public orderItem: OrderItem;
    @Input()
    public wizardFooterTemplate:  TemplateRef<any>;
    @Input()
    public focusInput: any;
    @Output()
    public onTabSelected: EventEmitter<PageVisit> = new EventEmitter<PageVisit>();

    public isAirCond?: boolean = null;

    public calculatorHelper = CalculatorHelper;

    /*getters*/
    public get isVehicle(): boolean {
        return CalculatorHelper.isVehicle(this.order);
    }

    public get isCanadianCalculator(): boolean {
        return CalculatorHelper.getCalculatorType(this.order.Locations) == CalculatorType.CanadianImport;
    }
    /*getters end*/

    constructor(private detectChanges: ChangeDetectorRef,
                public googleTagService: GoogleTagService) {}

    public setAirCondToOrder(): void {
        if (this.isAirCond)
            this.orderItem.Flags |= OrderItemOptions.IsAC;
        else if (this.orderItem.Flags)
            this.orderItem.Flags &= ~OrderItemOptions.IsAC;

    }

    public getAirCond(value: boolean, isAirCond: boolean): void {
        this.isAirCond = this.calculatorHelper.getButtonValue(value, isAirCond);
        this.detectChanges.detectChanges();
    }

    public getCommercial(value: boolean, IsCommercial: boolean): void {
        this.order.IsCommercial = this.calculatorHelper.getButtonValue(value, IsCommercial);
        this.detectChanges.detectChanges();
    }
}



// WEBPACK FOOTER //
// ./app/components/calculator/public/mobile/canadian-questions-tab/canadian-questions-tab-v2.component.ts